<template>
  <main
    v-if="$route.name === 'listini-edit-item'"
    id="create-item-page"
    class="page-container"
  >
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <form class="create-item-form" @submit.prevent="onUpdateItem">
      <!-- ── Campi comuni ─────────────────────────────────────────── -->
      <div class="create-item-row">
        <div class="field">
          <label for="item-code">Codice articolo</label>
          <input
            id="item-code"
            type="text"
            v-model.trim="formData.itemCode"
            placeholder="es. ART-001"
            maxlength="255"
          />
        </div>
        <div class="field">
          <label for="item-name">Nome articolo</label>
          <input
            id="item-name"
            type="text"
            v-model="formData.itemName"
            placeholder="inserisci"
          />
        </div>
      </div>

      <div class="create-item-row">
        <div class="field">
          <label for="brand">Brand</label>
          <input
            id="brand"
            type="text"
            v-model="formData.brand"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="serie">Serie</label>
          <input
            id="serie"
            type="text"
            v-model="formData.serie"
            placeholder="inserisci"
          />
        </div>
        <div class="field" v-if="category !== 'piastrelle'">
          <label for="price">Prezzo — IVA esclusa</label>
          <input
            id="price"
            type="number"
            step="any"
            v-model="formData.price"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="articleStatus">Stato</label>
          <StatusSelect
            v-model="formData.articleStatus"
            :options="articleStatusOptions"
          />
        </div>
      </div>

      <hr />

      <!-- ── Gruppo AREA (piastrelle, rivestimenti, parquet, laminati, decking) ── -->
      <template v-if="categoryGroup === 'area'">
        <!-- Piastrelle: selezione tipologia + campi variabili -->
        <template v-if="category === 'piastrelle'">
          <div class="create-item-row">
            <div class="field">
              <label>Tipologia *</label>
              <StatusSelect
                v-model="formData.subCategory"
                :options="subCategoryOptions"
                placeholder="Seleziona tipologia..."
                placeholderIcon="fa-tag"
              />
            </div>
          </div>

          <!-- Elementi Lineari (ML) -->
          <template v-if="tileGroup === 'linear'">
            <div class="create-item-row">
              <div class="field">
                <label for="formatLabel">Formato</label>
                <input
                  id="formatLabel"
                  type="text"
                  v-model="formData.formatLabel"
                  placeholder="es. 60x120"
                />
              </div>
              <div class="field">
                <label for="thicknessMm">Spessore (mm)</label>
                <input
                  id="thicknessMm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.thicknessMm"
                  placeholder="es. 10"
                />
              </div>
              <div class="field">
                <label for="finish">Finitura</label>
                <input
                  id="finish"
                  type="text"
                  v-model="formData.finish"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="mlPerBox">ML / scatola</label>
                <input
                  id="mlPerBox"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.mlPerBox"
                  placeholder="es. 2.5"
                />
              </div>
            </div>
          </template>

          <!-- Decori / Fondi (M2) -->
          <template v-else-if="tileGroup === 'area'">
            <div class="create-item-row">
              <div class="field">
                <label for="formatLabel">Formato</label>
                <input
                  id="formatLabel"
                  type="text"
                  v-model="formData.formatLabel"
                  placeholder="es. 60x120"
                />
              </div>
              <div class="field">
                <label for="widthCm">Larghezza (cm)</label>
                <input
                  id="widthCm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.widthCm"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="heightCm">Altezza (cm)</label>
                <input
                  id="heightCm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.heightCm"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="thicknessMm">Spessore (mm)</label>
                <input
                  id="thicknessMm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.thicknessMm"
                  placeholder="es. 10"
                />
              </div>
              <div class="field">
                <label for="finish">Finitura</label>
                <input
                  id="finish"
                  type="text"
                  v-model="formData.finish"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="sqmPerBox">M² / scatola</label>
                <input
                  id="sqmPerBox"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.sqmPerBox"
                  placeholder="es. 1.44"
                />
              </div>
            </div>
          </template>

          <!-- Battiscopa / Listelli / Gradini / Scalini / Altri Pezzi Speciali (PZ) -->
          <template v-else-if="tileGroup === 'piece'">
            <div class="create-item-row">
              <div class="field">
                <label for="formatLabel">Formato</label>
                <input
                  id="formatLabel"
                  type="text"
                  v-model="formData.formatLabel"
                  placeholder="es. 60x120"
                />
              </div>
              <div class="field">
                <label for="thicknessMm">Spessore (mm)</label>
                <input
                  id="thicknessMm"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.thicknessMm"
                  placeholder="es. 10"
                />
              </div>
              <div class="field">
                <label for="finish">Finitura</label>
                <input
                  id="finish"
                  type="text"
                  v-model="formData.finish"
                  placeholder="inserisci"
                />
              </div>
              <div class="field">
                <label for="sqmPerBox">M² / scatola</label>
                <input
                  id="sqmPerBox"
                  type="number"
                  step="any"
                  min="0"
                  v-model.number="formData.sqmPerBox"
                  placeholder="es. 1.44"
                />
              </div>
            </div>
          </template>

          <!-- Pz/scatola comune a tutti i tileGroup (la giacenza si
               gestisce dal magazzino, non dalla scheda articolo) -->
          <template v-if="tileGroup">
            <div class="create-item-row">
              <div class="field">
                <label for="piecesPerBox">Pz / scatola</label>
                <input
                  id="piecesPerBox"
                  type="number"
                  min="0"
                  v-model.number="formData.piecesPerBox"
                  placeholder="inserisci"
                />
              </div>
            </div>
            <div class="create-item-row">
              <div class="field">
                <label for="price">{{ priceLabel }} — IVA esclusa</label>
                <input
                  id="price"
                  type="number"
                  step="any"
                  v-model="formData.price"
                  placeholder="inserisci"
                />
              </div>
            </div>
          </template>
        </template>

        <!-- Parquet -->
        <template v-else-if="category === 'parquet'">
          <div class="create-item-row">
            <div class="field">
              <label for="material">Materiale (specie legnosa)</label>
              <StatusSelect
                v-model="formData.material"
                :options="parquetMaterialOptions"
                placeholder="Seleziona specie..."
                placeholderIcon="fa-tree"
              />
            </div>
            <div class="field">
              <label for="finish">Finitura (lavorazione)</label>
              <input
                id="finish"
                type="text"
                v-model="formData.finish"
                placeholder="es. Spazzolato naturale"
              />
            </div>
            <div class="field">
              <label for="scelta">Scelta</label>
              <StatusSelect
                v-model="formData.specs.scelta"
                :options="parquetSceltaOptions"
                placeholder="Seleziona scelta..."
                placeholderIcon="fa-shapes"
              />
            </div>
          </div>
          <div class="create-item-row">
            <div class="field">
              <label for="formatLabel">Formato</label>
              <input
                id="formatLabel"
                type="text"
                v-model="formData.formatLabel"
                placeholder="es. 65-70x440-490 mm"
              />
            </div>
            <div class="field">
              <label for="thicknessMm">Spessore (mm)</label>
              <input
                id="thicknessMm"
                type="number"
                step="any"
                min="0"
                v-model.number="formData.thicknessMm"
                placeholder="es. 10"
              />
            </div>
            <div class="field">
              <label for="widthCm">Larghezza (cm)</label>
              <input
                id="widthCm"
                type="number"
                step="any"
                min="0"
                v-model.number="formData.widthCm"
                placeholder="es. 6.5"
              />
            </div>
            <div class="field">
              <label for="lengthMm">Lunghezza (mm)</label>
              <input
                id="lengthMm"
                type="number"
                step="any"
                min="0"
                v-model.number="formData.lengthMm"
                placeholder="es. 440"
              />
            </div>
          </div>
          <!-- Dati imballo: senza M²/scatola l'articolo non è preventivabile
               (la quantità in mq non è convertibile in scatole) -->
          <div class="create-item-row">
            <div class="field">
              <label for="sqmPerBox">M² / scatola</label>
              <input
                id="sqmPerBox"
                type="number"
                step="any"
                min="0"
                v-model.number="formData.sqmPerBox"
                placeholder="es. 2.13"
              />
            </div>
            <div class="field">
              <label for="piecesPerBox">Pz / scatola</label>
              <input
                id="piecesPerBox"
                type="number"
                min="0"
                v-model.number="formData.piecesPerBox"
                placeholder="inserisci"
              />
            </div>
          </div>
        </template>

        <!-- Altre categorie area (rivestimenti parete, ecc.) -->
        <template v-else>
          <div class="create-item-row">
            <div class="field">
              <label for="formatLabel">Formato (es. 60x120)</label>
              <input
                id="formatLabel"
                type="text"
                v-model="formData.formatLabel"
                placeholder="es. 60x120"
              />
            </div>
            <div class="field">
              <label for="widthCm">Larghezza (cm)</label>
              <input
                id="widthCm"
                type="number"
                step="any"
                min="0"
                v-model.number="formData.widthCm"
                placeholder="inserisci"
              />
            </div>
            <div class="field">
              <label for="heightCm">Altezza (cm)</label>
              <input
                id="heightCm"
                type="number"
                step="any"
                min="0"
                v-model.number="formData.heightCm"
                placeholder="inserisci"
              />
            </div>
            <div class="field">
              <label for="thicknessMm">Spessore (mm)</label>
              <input
                id="thicknessMm"
                type="number"
                step="any"
                v-model="formData.thicknessMm"
                placeholder="es. 10"
              />
            </div>
            <div class="field">
              <label for="surface">Superficie</label>
              <input
                id="surface"
                type="text"
                v-model="formData.surface"
                placeholder="es. Matt, Lucido"
              />
            </div>
            <div class="field">
              <label for="color">Colore</label>
              <input
                id="color"
                type="text"
                v-model="formData.color"
                placeholder="inserisci"
              />
            </div>
          </div>
          <div class="create-item-row">
            <div class="field">
              <label for="sqmPerBox">M² / scatola</label>
              <input
                id="sqmPerBox"
                type="number"
                step="any"
                min="0"
                v-model.number="formData.sqmPerBox"
                placeholder="es. 1.44"
              />
            </div>
            <div class="field">
              <label for="piecesPerBox">Pz / scatola</label>
              <input
                id="piecesPerBox"
                type="number"
                min="0"
                v-model.number="formData.piecesPerBox"
                placeholder="inserisci"
              />
            </div>
          </div>
        </template>
      </template>

      <!-- ── Gruppo PIECE (sanitari, rubinetteria, box doccia, accessori) ── -->
      <template v-if="categoryGroup === 'piece'">
        <div class="create-item-row">
          <div v-if="category === 'sanitari'" class="field">
            <label for="fixtureType">Tipo</label>
            <StatusSelect
              v-model="formData.fixtureType"
              :options="fixtureTypeOptions"
            />
          </div>
          <div v-if="category === 'sanitari'" class="field">
            <label for="fixturePosition">Posizione</label>
            <StatusSelect
              v-model="formData.fixturePosition"
              :options="fixturePositionOptions"
            />
          </div>
          <div class="field">
            <label for="finish">Finitura</label>
            <input
              id="finish"
              type="text"
              v-model="formData.finish"
              placeholder="es. Cromo, Nero opaco"
            />
          </div>
          <div class="field">
            <label for="color">Colore</label>
            <input
              id="color"
              type="text"
              v-model="formData.color"
              placeholder="inserisci"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo LINEAR (profili, sistemi scarico) ── -->
      <template v-if="categoryGroup === 'linear'">
        <div class="create-item-row">
          <div class="field">
            <label for="material">Materiale</label>
            <input
              id="material"
              type="text"
              v-model="formData.material"
              placeholder="es. Alluminio, Inox"
            />
          </div>
          <div class="field">
            <label for="lengthMm">Lunghezza (mm)</label>
            <input
              id="lengthMm"
              type="number"
              step="any"
              min="0"
              v-model.number="formData.lengthMm"
              placeholder="es. 2500"
            />
          </div>
          <div class="field">
            <label for="mlPerBox">ML / confezione</label>
            <input
              id="mlPerBox"
              type="number"
              step="any"
              min="0"
              v-model.number="formData.mlPerBox"
              placeholder="es. 2.5"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo FURNITURE (mobili, porte e infissi) ── -->
      <template v-if="categoryGroup === 'furniture'">
        <div class="create-item-row">
          <div class="field">
            <label for="widthCm">Larghezza (cm)</label>
            <input
              id="widthCm"
              type="number"
              step="any"
              min="0"
              v-model.number="formData.widthCm"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="heightCm">Altezza (cm)</label>
            <input
              id="heightCm"
              type="number"
              step="any"
              min="0"
              v-model.number="formData.heightCm"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="material">Materiale</label>
            <input
              id="material"
              type="text"
              v-model="formData.material"
              placeholder="es. MDF, Rovere"
            />
          </div>
          <div class="field">
            <label for="finish">Finitura</label>
            <input
              id="finish"
              type="text"
              v-model="formData.finish"
              placeholder="es. Bianco opaco"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo BATH (bagno) ── -->
      <template v-if="categoryGroup === 'bath'">
        <div class="create-item-row">
          <div class="field">
            <label>Tipologia</label>
            <input
              type="text"
              :value="formData.subCategory"
              readonly
              placeholder="—"
            />
          </div>
        </div>
      </template>

      <!-- ── Gruppo GENERIC (altro) ── -->
      <template v-if="categoryGroup === 'generic'">
        <div class="create-item-row">
          <div class="field">
            <label for="notes">Note</label>
            <textarea
              id="notes"
              v-model="formData.notes"
              placeholder="inserisci"
              rows="3"
            />
          </div>
        </div>
      </template>

      <hr />

      <div class="save-button-container">
        <button
          id="create-item-button"
          class="primary-btn"
          type="submit"
          :disabled="!isDirty"
          :aria-disabled="!isDirty"
          :title="
            !isDirty ? 'Modifica almeno uno dei campi' : 'Aggiorna articolo'
          "
        >
          Aggiorna
        </button>
      </div>
    </form>

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import StatusSelect from "@/components/StatusSelect.vue";

const COLUMN_GROUPS = {
  area: [
    "piastrelle",
    "rivestimenti parete",
    "parquet",
    "laminati",
    "decking esterno",
  ],
  piece: ["sanitari", "rubinetteria", "box doccia", "accessori bagno"],
  linear: ["profili", "sistemi di scarico"],
  furniture: ["mobili", "porte e infissi"],
  bath: ["bagno"],
};

function getCategoryGroup(category) {
  for (const [group, cats] of Object.entries(COLUMN_GROUPS)) {
    if (cats.includes(category)) return group;
  }
  return "generic";
}

export default {
  name: "EditItemPage",
  components: { StatusSelect },
  beforeRouteLeave(to) {
    if (this.navigationConfirmed || to.name === "login" || !this.isDirty) {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  props: ["itemId"],
  data() {
    return {
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      articleStatusOptions: [
        { value: "attivo", label: "Attivo", color: "#059669" },
        { value: "novita", label: "Novità", color: "#2563eb" },
        { value: "discontinuo", label: "Discontinuo", color: "#9ca3af" },
      ],
      fixtureTypeOptions: [
        { value: "", label: "— scegli —" },
        { value: "vaso", label: "Vaso", icon: "fa-toilet" },
        { value: "bidet", label: "Bidet", icon: "fa-water" },
        { value: "lavabo", label: "Lavabo", icon: "fa-droplet" },
        { value: "box doccia", label: "Box doccia", icon: "fa-shower" },
        { value: "piatto doccia", label: "Piatto doccia", icon: "fa-grip" },
        { value: "vasca", label: "Vasca", icon: "fa-bath" },
        {
          value: "mobile bagno",
          label: "Mobile bagno",
          icon: "fa-layer-group",
        },
        { value: "specchiera", label: "Specchiera", icon: "fa-image" },
        { value: "rubinetteria", label: "Rubinetteria", icon: "fa-faucet" },
        { value: "idraulica", label: "Idraulica", icon: "fa-wrench" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      subCategoryOptions: [
        { value: "Elementi Lineari", label: "Elementi Lineari" },
        { value: "Decori", label: "Decori" },
        { value: "Fondi", label: "Fondi" },
        { value: "Battiscopa", label: "Battiscopa" },
        { value: "Listelli", label: "Listelli" },
        { value: "Gradini", label: "Gradini" },
        { value: "Scalini", label: "Scalini" },
        { value: "Altri Pezzi Speciali", label: "Altri Pezzi Speciali" },
      ],
      fixturePositionOptions: [
        { value: "", label: "— scegli —" },
        { value: "sospeso", label: "Sospeso", icon: "fa-arrow-up" },
        { value: "terra", label: "A terra", icon: "fa-arrow-down" },
        { value: "mono-blocco", label: "Mono-blocco", icon: "fa-cube" },
        { value: "nessuno", label: "Nessuno", icon: "fa-ban" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      parquetMaterialOptions: [
        { value: "", label: "— nessuna —" },
        { value: "ROVERE", label: "Rovere" },
        { value: "TEAK", label: "Teak" },
        { value: "IROKO", label: "Iroko" },
        { value: "DOUSSIE", label: "Doussié" },
      ],
      parquetSceltaOptions: [
        { value: "", label: "— nessuna —" },
        { value: "CERCHIO", label: "Cerchio" },
        { value: "QUADRATO", label: "Quadrato" },
        { value: "TRIANGOLO", label: "Triangolo" },
      ],
      // MODALITÀ IMMUTABILE dell'articolo, fissata UNA SOLA VOLTA al
      // caricamento: true se l'articolo ha un codice fornitore (supplierCode).
      // Non cambia se l'utente modifica o svuota il campo "Codice articolo":
      // così un articolo importato non può "diventare" manuale.
      usesSupplierCode: false,
      formData: {
        itemCode: "",
        itemName: "",
        brand: "",
        serie: "",
        price: 0,
        articleStatus: "attivo",
        // piastrelle
        subCategory: "",
        salesUnit: "",
        // area
        formatLabel: "",
        thicknessMm: "",
        surface: "",
        color: "",
        piecesPerBox: "",
        sqmPerBox: "",
        boxQuantity: "",
        // piece
        fixtureType: "",
        fixturePosition: "",
        finish: "",
        // linear
        material: "",
        lengthMm: "",
        mlPerBox: "",
        // furniture
        widthCm: "",
        heightCm: "",
        // parquet
        specs: { scelta: "" },
        // generic
        notes: "",
        // common
        entryDate: "",
      },
      originalSnapshot: null,
      hasLoaded: false,
      errorMessage: "",
      successMessage: "",
    };
  },
  computed: {
    category() {
      return decodeURIComponent(this.$route.params.category || "");
    },
    categoryGroup() {
      return getCategoryGroup(this.category);
    },
    tileGroup() {
      if (this.category !== "piastrelle") return null;
      const sub = this.formData.subCategory;
      if (sub) {
        if (sub === "Elementi Lineari") return "linear";
        if (sub === "Decori" || sub === "Fondi") return "area";
        if (
          [
            "Battiscopa",
            "Listelli",
            "Gradini",
            "Scalini",
            "Altri Pezzi Speciali",
          ].includes(sub)
        )
          return "piece";
      }
      const su = this.formData.salesUnit;
      if (su === "ML") return "linear";
      if (su === "M2") return "area";
      if (su === "PZ") return "piece";
      return null;
    },
    priceLabel() {
      const g = this.tileGroup;
      if (g === "linear") return "Prezzo / ML";
      if (g === "area") return "Prezzo / M²";
      if (g === "piece") return "Prezzo / pz";
      return "Prezzo";
    },
    isDirty() {
      if (!this.hasLoaded) return false;
      return (
        JSON.stringify(this.snapshotCurrent()) !==
        JSON.stringify(this.originalSnapshot)
      );
    },
  },
  methods: {
    goBack() {
      this.pendingNavigation = null;
      // Nessuna modifica: torna indietro senza conferma.
      if (!this.isDirty) {
        this.navigationConfirmed = true;
        this.$router.back();
        return;
      }
      this.showBackModal = true;
    },
    // Guardia reload/chiusura tab nativa del browser: dialog nativo di
    // conferma solo se ci sono modifiche non salvate.
    handleBeforeUnload(e) {
      if (!this.isDirty) return;
      e.preventDefault();
      e.returnValue = "";
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        this.$router.back();
      }
    },
    ...mapActions(["updateItem"]),

    snapshotCurrent() {
      const str = (v) => (v == null ? "" : String(v).trim());
      const num = (v) => (v === "" || v == null ? null : Number(v));
      const f = this.formData;
      return {
        itemCode: str(f.itemCode),
        itemName: str(f.itemName),
        brand: str(f.brand),
        serie: str(f.serie),
        price: num(f.price),
        articleStatus: str(f.articleStatus),
        formatLabel: str(f.formatLabel),
        thicknessMm: num(f.thicknessMm),
        surface: str(f.surface),
        color: str(f.color),
        piecesPerBox: num(f.piecesPerBox),
        sqmPerBox: num(f.sqmPerBox),
        boxQuantity: num(f.boxQuantity),
        fixtureType: str(f.fixtureType),
        fixturePosition: str(f.fixturePosition),
        finish: str(f.finish),
        material: str(f.material),
        lengthMm: num(f.lengthMm),
        mlPerBox: num(f.mlPerBox),
        widthCm: num(f.widthCm),
        heightCm: num(f.heightCm),
        subCategory: str(f.subCategory),
        salesUnit: str(f.salesUnit),
        scelta: str(f.specs?.scelta),
        notes: str(f.notes),
        entryDate: str(f.entryDate),
      };
    },

    async fetchItemData() {
      try {
        const response = await this.$axios.get(`item/${this.itemId}`);
        if (response.status === 200) {
          const itemData = response.data.item;
          const boxQuantity = itemData.warehouse?.boxQuantity ?? null;
          this.usesSupplierCode = itemData.supplierCode != null;
          this.formData = {
            ...this.formData,
            ...itemData,
            // "Codice articolo": supplierCode per gli articoli importati,
            // altrimenti itemCode. Il codice tecnico interno resta nascosto.
            itemCode: this.usesSupplierCode
              ? itemData.supplierCode
              : itemData.itemCode,
            boxQuantity,
            specs: { scelta: itemData.specs?.scelta ?? "" },
            entryDate: itemData.entryDate
              ? itemData.entryDate.slice(0, 10)
              : "",
          };
          this.$nextTick(() => {
            this.originalSnapshot = this.snapshotCurrent();
            this.hasLoaded = true;
            this.$toast.success(`Articolo caricato.`);
          });
        }
      } catch (error) {
        this.$toast.error(
          error.response?.data?.message || "Impossibile caricare i dati."
        );
      }
    },

    async onUpdateItem() {
      // per gli articoli importati il codice (mappato su supplierCode)
      // è OBBLIGATORIO e non può essere svuotato: blocco prima di chiamare l'API.
      if (this.usesSupplierCode && !(this.formData.itemCode || "").trim()) {
        this.$toast.error("Il codice articolo è obbligatorio.");
        return;
      }
      const toNum = (v) => (v === "" || v == null ? null : Number(v));
      const toStr = (v) => (v === "" ? null : v || null);
      try {
        const payload = {
          itemName: this.formData.itemName,
          brand: this.formData.brand,
          serie: this.formData.serie,
          price: this.formData.price,
          articleStatus: this.formData.articleStatus,
          category: this.category,
          subCategory: toStr(this.formData.subCategory),
          salesUnit: this.formData.salesUnit || null,
          formatLabel: toStr(this.formData.formatLabel),
          thicknessMm: toNum(this.formData.thicknessMm),
          surface: toStr(this.formData.surface),
          color: toStr(this.formData.color),
          piecesPerBox: toNum(this.formData.piecesPerBox),
          sqmPerBox: toNum(this.formData.sqmPerBox),
          fixtureType: toStr(this.formData.fixtureType),
          fixturePosition: toStr(this.formData.fixturePosition),
          finish: toStr(this.formData.finish),
          material: toStr(this.formData.material),
          lengthMm: toNum(this.formData.lengthMm),
          mlPerBox: toNum(this.formData.mlPerBox),
          widthCm: toNum(this.formData.widthCm),
          heightCm: toNum(this.formData.heightCm),
          notes: toStr(this.formData.notes),
          entryDate: this.formData.entryDate || null,
        };

        if (this.category === "parquet") {
          payload.specs = this.formData.specs?.scelta
            ? { scelta: this.formData.specs.scelta }
            : null;
        }

        // il campo "Codice articolo" aggiorna supplierCode se
        // l'articolo ne possiede uno (articoli importati); altrimenti itemCode.
        // La chiave tecnica itemCode NON viene inviata né rigenerata quando
        // esiste supplierCode. Il riconoscimento si basa sulla presenza reale
        // di supplierCode, non sul prefisso del codice.
        if (this.usesSupplierCode) {
          payload.supplierCode = this.formData.itemCode;
        } else {
          payload.itemCode = this.formData.itemCode;
        }

        const response = await this.$store.dispatch("updateItem", {
          itemId: this.itemId,
          payload,
        });
        if (response.status === 200) {
          this.$toast.success(response.data?.message || "Articolo aggiornato!");
          this.originalSnapshot = this.snapshotCurrent();
          setTimeout(() => {
            this.navigationConfirmed = true;
            this.$router.push({
              name: "listini-category",
              params: { category: this.category },
            });
          }, 1000);
        }
      } catch (error) {
        if (
          error.response?.status === 409 &&
          error.response?.data?.code === "ITEM_CODE_DUPLICATE"
        ) {
          this.$toast.error(
            "Questo codice è già utilizzato da un altro articolo."
          );
        } else {
          this.$toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante l'aggiornamento."
          );
        }
      }
    },
  },
  watch: {
    "formData.subCategory"(newSub) {
      if (!newSub) {
        this.formData.salesUnit = "";
        return;
      }
      if (newSub === "Elementi Lineari") this.formData.salesUnit = "ML";
      else if (newSub === "Decori" || newSub === "Fondi")
        this.formData.salesUnit = "M2";
      else this.formData.salesUnit = "PZ";
    },
  },
  mounted() {
    this.fetchItemData();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
